import Typography from '@mui/material/Typography';

export default function HeaderSectionBlood({ headline_p1, headline_grey, headline_p2}) {
   
    return (
     <>

               
              { <Typography variant="h3" fontWeight={400}> {headline_p1} 
                    <Typography component="span" variant="h3" sx={{ color: 'grey.dark'}}>  {headline_grey}  </Typography> 
                            {headline_p2} 
                        </Typography>} 

                  
  </>
    );
  }